import {Http} from "../../plugins/axios";
export function getTournament (id)
{
  return new Http().get(`webview/tournament/${id}`)
}

export function getRRRooms (id) {
  return new Http().get(`tournaments/round-robin/${id}/rooms`)
}

export function getResults (id) {
  return new Http().get(`tournaments/${id}/results`)
}

export function getMatches (id) {
  return new Http().get(`tournaments/${id}/matches`)
}

export function getTftMatches (id) {
  return new Http().get(`tournaments/${id}/tft/matches`)
}
